import React from 'react';
import HorarioSemanal from './business/HorarioSemanal';

/**
 * Horarios del negocio.
 *
 * La interfaz vive en components/business/HorarioSemanal.jsx: una grilla tipo
 * calendario donde se arrastra para marcar cuándo se atiende, en vez de los
 * cuatro desplegables por rango que había antes.
 *
 * Este archivo queda como puerta de entrada porque lo usan el onboarding y la
 * configuración del panel con los mismos props. `hours` y `minutes` ya no hacen
 * falta —la grilla trabaja en minutos— pero se siguen aceptando para no obligar
 * a tocar a quienes lo llaman. `businessSchedule` tampoco: servía para proponer
 * el horario del negocio al abrir un día, y ahora esa propuesta la hace la
 * propia grilla.
 */
export default function BusinessScheduleForm({ value, onChange, dayNames }) {
  return <HorarioSemanal value={value || {}} onChange={onChange} dayNames={dayNames} />;
}
